<div style="display:inline-block" mat-dialog-content *ngIf="changedFiles.length > 0">
    <h1 mat-dialog-title>Duplicate File Name</h1>
    You have uploaded multiple files with the file name(s) {{changedFiles}} which may be duplicative.<br>
    We have renamed the additional files(s) as {{newFiles}}
</div>

<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Close</button>
</div>
